// extracted by mini-css-extract-plugin
export var textInput = "_e5-0";